import { render, staticRenderFns } from "./account-platform.vue?vue&type=template&id=6eecd3eb&scoped=true"
import script from "./account-platform.vue?vue&type=script&lang=js"
export * from "./account-platform.vue?vue&type=script&lang=js"
import style0 from "./account-platform.vue?vue&type=style&index=0&id=6eecd3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eecd3eb",
  null
  
)

export default component.exports